// i18next yapılandırması. Çeviri dosyaları BUNDLE'A dahil edilmiyor — public/locales/{dil}/
// altında ayrı JSON dosyaları olarak duruyor ve i18next-http-backend ile sadece o an seçili
// olan dil, ihtiyaç anında (lazy) HTTP ile çekiliyor. Böylece 9 dil eklemek ana JS paketinin
// boyutunu ARTIRMIYOR — sadece kullanıcının seçtiği dilin küçük JSON dosyası indiriliyor.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// "flag" burada emoji DEĞİL, /public/flags/{kod}.svg altındaki gerçek SVG bayrak dosyasının
// adı — emoji bayraklar Windows'ta (Segoe UI Emoji'nin bölgesel gösterge dizilerini flag
// glифüne çevirmemesi nedeniyle) genelde harf çiftine ("GB", "TR" gibi) düşüyor, bu yüzden
// gerçek SVG kullanılıyor (flag-icons paketinden alınmış, platform bağımsız çalışır).
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flag: 'gb' },
  { code: 'tr', label: 'Türkçe', flag: 'tr' },
  { code: 'ja', label: '日本語', flag: 'jp' },
  { code: 'de', label: 'Deutsch', flag: 'de' },
  { code: 'fr', label: 'Français', flag: 'fr' },
  { code: 'zh', label: '中文', flag: 'cn' },
  { code: 'it', label: 'Italiano', flag: 'it' },
  { code: 'es', label: 'Español', flag: 'es' },
  { code: 'ru', label: 'Русский', flag: 'ru' },
];

// Kullanıcı daha önce bir dil seçtiyse onu hatırla; seçmediyse ana dil İngilizce (tarayıcı
// dilini otomatik algılayıp değiştirmiyoruz — kullanıcı bilinçli olarak isterse bayrağa basar).
const savedLanguage = (() => {
  try {
    return localStorage.getItem('xpa_language');
  } catch (_) {
    return null;
  }
})();

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage || 'en',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    ns: ['home'],
    defaultNS: 'home',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // React zaten XSS'e karşı kaçış yapıyor
    },
    react: {
      useSuspense: true, // App.js'deki mevcut <Suspense> sınırıyla uyumlu çalışır
    },
  });

export default i18n;
